import { render, staticRenderFns } from "./service-detail.vue?vue&type=template&id=6105d7b8&scoped=true"
import script from "./service-detail.vue?vue&type=script&lang=js"
export * from "./service-detail.vue?vue&type=script&lang=js"
import style0 from "./service-detail.vue?vue&type=style&index=0&id=6105d7b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6105d7b8",
  null
  
)

export default component.exports